<template>
  <div class="lian-detail-wrap">
    <div class="search-form">
      <div class="select-wrap">
        <div>
          <span>交易时间： </span>
          <el-date-picker
            v-model="searchForm.time"
            @change="onChangeTime"
            :clearable="false"
            unlink-panels
            type="daterange"
            format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </div>
        <div>
          <span>交易类型： </span>
          <el-select
            v-model="searchForm.trxType"
            size="small"
            multiple
            clearable
            placeholder="请选择交易类型"
          >
            <el-option
              v-for="item in trxOptions"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <span>供货渠道： </span>
          <el-select
            v-model="searchForm.bizCategory"
            size="small"
            clearable
            placeholder="请选择供货渠道"
          >
            <el-option
              v-for="item in bizCategoryList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="tool-btn">
        <el-button type="primary" @click="getData" size="small">查询</el-button>
        <el-button type="primary" @click="exportDetail" size="small">导出明细</el-button>
      </div>
    </div>

    <div class="detail-list-table">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        @expand-change="expandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div>
              <el-table :data="props.row.child" style="width: 100%">
                <el-table-column prop="serialNum" label="序号">
                </el-table-column>
                <el-table-column prop="settleBillNo" label="结算单号">
                </el-table-column>
                <el-table-column prop="orderNo" label="订单号">
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="交易时间"></el-table-column>
        <el-table-column prop="tradeTypeDesc" label="交易类型"></el-table-column>
        <el-table-column prop="orderNumber" label="单号"></el-table-column>
        <el-table-column prop="amount" label="交易金额">
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
            <div style="color: red" v-if="scope.row.tradeType == 3">
              <span>（手续费：¥</span><span>{{ scope.row.withdrawFeeAmount }}</span>）
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="purseType" label="支付类型">
          <template slot-scope="scope">
            {{ scope.row.purseType | filterPurse }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseChannel" label="供货渠道">
          <template slot-scope="scope">
            {{ scope.row.bizCategory | filterBizCategory }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// cosnt disabledDate = current => current && current > moment().endOf('day') || current < moment().subtract(3, 'months')
import moment from "moment";
import {
  getTransactionRecords,
  getLianLianDetailItem,
} from "@/models/purseSet";
import { buildURL } from "@/utils/utils";

export default {
  props: {
    supplierId: "",
    trxOptions: [], // 交易类型枚举
    detailInfo: {
      activeCorp: "",
      activeName: "",
    },
  },
  data() {
    return {
      // 搜索筛选
      searchForm: {
        time: [moment().subtract(3, "months").valueOf(), moment().valueOf()],
        trxType: [],
        bizCategory: '',
      },
      currentPage: 1,
      totalCount: 0,
      pagesize: 10,
      loading: false,
      // 明细列表数据
      tableData: [],
      // 供货渠道下拉选项
      bizCategoryList: [
        {
          value: "1",
          text: "现采",
        },
        {
          value: "2",
          text: "寄售",
        },
        {
          value: "4",
          text: "大菠萝",
        },
        {
          value: "5",
          text: "工厂通",
        },
      ],
    };
  },
  filters: {
    filterPurse(val) {
      let str = "";
      switch (val) {
        case 1:
          str = "锐锢钱袋";
          break;
        case 2:
          str = "连连钱袋";
          break;
        default:
          break;
      }
      return str;
    },

    filterBizCategory(val) {
      let str = "";
      switch (val) {
        case 1:
          str = "现采";
          break;
        case 2:
          str = "寄售";
          break;
        case 4:
          str = "大菠萝";
          break;
        case 5:
          str = "工厂通";
          break;
        default:
          break;
      }
      return str;
    },
  },

  created() {},

  methods: {
    moment,
    onChangeTime(value) {
      this.searchForm.time = value;
      let time = [];
      time[0] = Object.assign({}, moment(value[0]));
      time[1] = Object.assign({}, moment(value[1]));
      let startTime = moment(time[0]);
      let endtTime = moment(time[1]).subtract(1, "days");
      if (!endtTime.subtract(3, "months").isBefore(startTime)) {
        this.$message.error("选择的时间跨度最大为3个月");
        this.searchForm.time = [
          moment().subtract(3, "months").valueOf(),
          moment().valueOf(),
        ];
      } else {
        this.searchForm.time = value;
      }
    },

    // 查询
    getData() {
      this.currentPage = 1;
      this.initData();
    },

    // 初始化连连交易明细列表
    initData() {
      this.loading = true;
      const type = this.detailInfo.activeName == "LianLian" ? 2 : 1;
      let params = {
        supplierId: this.supplierId,
        corpId: this.detailInfo.activeCorp,
        purseType: type,
        page: this.currentPage - 1,
        size: this.pagesize,
        tradeTypeList: this.searchForm.trxType.join(","),
        purchaseChannel: 4,
        bizCategory: this.searchForm.bizCategory
      };
      if (this.searchForm.time.length === 0) {
        params.queryStart = moment().subtract(3, "months").startOf('day').format('YYYY-MM-DD HH:mm:ss');
        params.queryEnd = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        params.queryStart = moment(this.searchForm.time[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        params.queryEnd = moment(this.searchForm.time[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      //console.log(params, '入参 params');
      getTransactionRecords(params)
        .then((res) => {
          this.tableData = res ? res.data.content.map((item, index) => {
            item.child = [];       // 先给一个空值
            item.expand = false;  // 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
            return item;
          }) : [];
          this.totalCount = parseInt(res.data.totalElements);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg);
        });
    },

    /* 展开子表格 */
    expandChange(row, expandedRows) {
      if (!row.expand) {
        // 先判断该行是否已经展开了
        getLianLianDetailItem({
          tradeNo: row.orderNumber,
          corpId: this.detailInfo.activeCorp,
          supplierId: this.supplierId,
        })
          .then((res) => {
            if (res.code === 200) {
              row.expand = true;          // 设置展开行是打开的
              row.child = res
                ? res.data.map((item, index) => {
                    item.serialNum = index + 1;
                    return item;
                  })
                : [];
            } else {
              row.expand = true;          // 设置展开行是打开的
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      } else {
        row.expand = false;
      }
    },

    /*
      导出入参
    */
    exportDetail() {
      const type = this.detailInfo.activeName == "LianLian" ? 2 : 1;
      let params = {
        supplierId: this.supplierId,
        corpId: this.detailInfo.activeCorp,
        purchaseChannel: 4,
        purseType: type,
        tradeTypeList: this.searchForm.trxType.join(","),
        bizCategory: this.searchForm.bizCategory
      };
     if (this.searchForm.time.length === 0) {
        params.queryStart = moment().subtract(3, "months").startOf('day').format('YYYY-MM-DD HH:mm:ss');
        params.queryEnd = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        params.queryStart = moment(this.searchForm.time[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        params.queryEnd = moment(this.searchForm.time[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      const url = `${myhostname}/pay/clear/lianlian/export/?access_token=${localStorage.getItem("token")}&${buildURL(params)}`;
      window.open(url);
    },

    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1;
      this.initData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.initData();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.lian-detail-wrap {
  .select-wrap {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .select-wrap > div {
    padding-right: 20px;
  }

  .tool-btn {
    margin-bottom: 20px;
    display: flex;
    justify-content: end;
    align-items: start;
  }

  .checkbox {
    margin-left: 15px;
  }

  .el-range-editor.el-input__inner {
    height: 32px;
    line-height: 32px;
    margin-top: 0;
  }

  .detail-list-table {
    .el-table {
      /deep/ .el-table__header-wrapper {
        .highlight {
          color: #ff6224 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/record/components/LianTransDetail.vue